import { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SectionContext = createContext();

export const SectionProvider = ({ children }) => {
  const [section, setSection] = useState(() => {
    return sessionStorage.getItem('plannic-section') || null;
  });
  const location = useLocation();

  // Auto-detect section from URL
  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith('/architecture')) {
      setSection('architecture');
    } else if (path.startsWith('/cad-services')) {
      setSection('cad');
    } else if (path === '/') {
      setSection(null);
    }
  }, [location.pathname]);

  // Persist to sessionStorage
  useEffect(() => {
    if (section) {
      sessionStorage.setItem('plannic-section', section);
    } else {
      sessionStorage.removeItem('plannic-section');
    }
  }, [section]);

  return (
    <SectionContext.Provider value={{ section, setSection }}>
      {children}
    </SectionContext.Provider>
  );
};

export const useSection = () => useContext(SectionContext);
